(() => {
  // app/scripts/common/function/linkOptions.js
  var linkOptions = (container, product, cb) => {
    let optionsMap = {};
    if (!container) {
      return;
    }
    let statusWhenVariantSoldOut = container.dataset.status;
    let optionElements = container.getElementsByClassName("js-option-item");
    if (product.variants.length <= 1) {
      return;
    }
    optionElements.addEvents("change", function() {
      container.dispatchEvent(new CustomEvent("swatch-change", { detail: +this.dataset.optionPosition }));
    });
    container.addEvent("swatch-change", function({ detail: position }) {
      switch (position) {
        case 1:
          if (product.options.length > 1) {
            updateOptionsInSelector(2);
          } else {
            cb(findVariantFromOption(getValueOptions()));
          }
          break;
        case 2:
          if (product.options.length === 3) {
            product.options.length === 3 && updateOptionsInSelector(3);
          } else {
            cb(findVariantFromOption(getValueOptions()));
          }
          break;
        case 3:
          cb(findVariantFromOption(getValueOptions()));
          break;
      }
    });
    product.variants.forEach((variant) => {
      if (variant.available) {
        optionsMap["root"] = optionsMap["root"] || [];
        optionsMap["root"].push(variant.option1);
        optionsMap["root"] = optionsMap["root"].reduce((accu, currentvalue) => {
          if (!accu.includes(currentvalue)) {
            accu.push(currentvalue);
          }
          return accu;
        }, []);
        if (product.options.length > 1) {
          var key = variant.option1;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option2);
          optionsMap[key] = optionsMap[key].reduce((accu, currentvalue) => {
            if (!accu.includes(currentvalue)) {
              accu.push(currentvalue);
            }
            return accu;
          }, []);
        }
        if (product.options.length === 3) {
          var key = variant.option1 + " / " + variant.option2;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option3);
          optionsMap[key] = optionsMap[key].reduce((accu, currentvalue) => {
            if (!accu.includes(currentvalue)) {
              accu.push(currentvalue);
            }
            return accu;
          }, []);
        }
      }
    });
    updateOptionsInSelector(1);
    function updateOptionsInSelector(index) {
      if (!Object.keys(optionsMap).length)
        return;
      let setValue = false;
      let optionValues = getValueOptions();
      let key, selector, old_value;
      switch (index) {
        case 1:
          key = "root";
          selector = container.querySelector(".js-swatch-item[data-position='1']");
          break;
        case 2:
          key = optionValues.option1;
          selector = container.querySelector(".js-swatch-item[data-position='2']");
          break;
        case 3:
          key = optionValues.option1 + " / " + optionValues.option2;
          selector = container.querySelector(".js-swatch-item[data-position='3']");
          break;
      }
      switch (selector.dataset.style) {
        case "select": {
          let selectElement = selector.getElementsByClassName("js-option-item")[0];
          let oldValue2 = selectElement.value;
          switch (statusWhenVariantSoldOut) {
            case "hide": {
              selectElement.innerHTML = optionsMap[key].map((optionValue) => `<option value="${optionValue}">${optionValue}</option>`).join("");
              if (optionsMap[key].includes(oldValue2)) {
                selectElement.value = oldValue2;
              }
              break;
            }
            case "disable": {
              [...selectElement.options].forEach((option) => {
                if (optionsMap[key].includes(option.value)) {
                  option.disabled = false;
                } else {
                  option.disabled = true;
                  option.value === oldValue2 && (option.selected = false);
                }
              });
              break;
            }
          }
          break;
        }
        case "color":
        case "button":
          let inputsElement = selector.getElementsByClassName("js-option-item");
          let oldValue = [...inputsElement].find((input) => input.checked).value;
          switch (statusWhenVariantSoldOut) {
            case "hide":
              inputsElement.forEach((input) => {
                if (optionsMap[key].includes(input.value)) {
                  input.parentElement.removeClass("d-none");
                } else {
                  input.parentElement.addClass("d-none");
                  oldValue === input.value && (input.checked = false, inputsElement[0].checked = true);
                }
              });
              break;
            case "disable": {
              inputsElement.forEach((input) => {
                if (optionsMap[key].includes(input.value)) {
                  input.disabled = false;
                } else {
                  input.disabled = true;
                  oldValue === input.value && (input.checked = false, inputsElement[0].checked = true);
                }
              });
              break;
            }
          }
          break;
      }
      container.dispatchEvent(new CustomEvent("swatch-change", { detail: index }));
    }
    function getValueOptions() {
      return [...container.getElementsByClassName("js-swatch-item")].reduce((accu, element) => {
        switch (element.dataset.style) {
          case "select":
            let select = element.querySelector("select.single-option-selector");
            accu[select.name] = select.value;
            break;
          case "color":
          case "image":
          case "button":
            let inputsElements = element.querySelectorAll("input[data-single-option-selector]");
            accu[inputsElements[0].name] = [...inputsElements].find((input) => input.checked).value;
            break;
        }
        return accu;
      }, {});
    }
    function findVariantFromOption(options) {
      return product.variants.find((variant) => {
        return Object.keys(options).every((optionKey) => variant[optionKey] === options[optionKey]);
      });
    }
  };

  // app/scripts/common/function/saveProductToCookie.js
  var saveProductToCookie = () => {
    let currentProductHandle = theme.product.handle;
    let productHandleArray = AT.cookie.get("recently-viewed-products") || [];
    if (productHandleArray.length) {
      !productHandleArray.includes(currentProductHandle) && productHandleArray.unshift(currentProductHandle);
      productHandleArray.length = 10;
    } else {
      productHandleArray.unshift(currentProductHandle);
    }
    AT.cookie.set("recently-viewed-products", productHandleArray.filter(Boolean), 7);
  };

  // app/scripts/common/section/product-no-sidebar.js
  var ProductNoSbTemplate = {
    onLoad: function() {
      let container = this.container;
      this.product = theme.product;
      this.elms = {
        swatchContainer: container.querySelector(".swatch-list"),
        productWrapperElement: container.querySelector(".js-product-wrapper"),
        priceCompareElement: container.querySelector(".js-compare-at-price"),
        priceElement: container.querySelector(".js-product-price"),
        saleLabelElement: container.querySelector(".js-label_ui-sale"),
        variantAvailableStatus: container.querySelector(".js-product-status"),
        skuElement: container.querySelector(".js-product-sku"),
        mainMediaContainer: document.querySelector(".js-slider-main"),
        thumbnailsMediaContainer: document.querySelector(".js-slider-thumbnails"),
        tabPanelElement: container.querySelector(".js-tab-panel"),
        selectMaster: container.querySelector("#selected_variant"),
        inputQuantityContainer: container.querySelector(".js-input-quantity-container"),
        productFormInput: container.querySelector("#product_form_input"),
        formElm: container.querySelector(".js-form-add-to-card"),
        buttonAddToCart: document.querySelector(".js-btn-add-to-cart"),
        swatchFormContainer: container.querySelector(".js-swatch-form"),
        subscribeForm: document.querySelector("#contact-notify-when-available")
      };
      this.initSlideMedia();
      this.initReviewScroll();
      AT.initInputQuantity(this.elms.inputQuantityContainer);
      AT.initTabPanel(this.elms.tabPanelElement);
      AT.initFormAddToCart(this.elms.formElm);
      linkOptions(this.elms.swatchFormContainer, this.product, this.handleVariantChange.bind(this));
      if (AT.getParameterByName("contact_posted")) {
        this.switchVariantById(AT.cookie.get("subscribe-variant-id"));
        AT.cookie.delete("subscribe-variant-id");
        let searchParams = window.location.search.replace("?", "").split("&").filter((param) => !param.includes("contact_posted")).filter(Boolean).join("&");
        window.history.replaceState({}, "", `${window.location.pathname}?${searchParams}`);
        document.querySelector("#btn_pre_order").click();
      }
    },
    initSlideMedia: function() {
      let { mainMediaContainer, thumbnailsMediaContainer } = this.elms;
      let mainMediaSlider, thumbnailsMediaSlider;
      initMediaMainEvent.call(this);
      (() => {
        if (!thumbnailsMediaContainer) {
          return;
        }
        let config = JSON.parse(thumbnailsMediaContainer.querySelector("[data-tns-config]").innerHTML);
        let axis;
        if (window.innerWidth >= 768) {
          axis = "vertical";
          config.axis = axis;
          thumbnailsMediaSlider = tns(config);
        } else {
          axis = "horizontal";
          config.axis = axis;
          thumbnailsMediaSlider = tns(config);
        }
        window.addEvent("resize", () => {
          if (window.innerWidth >= 768 && axis !== "vertical") {
            thumbnailsMediaSlider.destroy();
            axis = "vertical";
            config.axis = axis;
            thumbnailsMediaSlider = tns(config);
            this.mainSlider.destroy();
            initMediaMainEvent.call(this);
          } else if (window.innerWidth <= 767.9 && axis !== "horizontal") {
            thumbnailsMediaSlider.destroy();
            axis = "horizontal";
            config.axis = axis;
            thumbnailsMediaSlider = tns(config);
            this.mainSlider.destroy();
            initMediaMainEvent.call(this);
          }
        });
      })();
      function initMediaMainEvent() {
        if (!mainMediaContainer) {
          return;
        }
        let configElement = mainMediaContainer.querySelector("[data-tns-config]");
        if (!configElement) {
          return;
        }
        let config = JSON.parse(configElement.innerHTML);
        this.mainSlider = tns(config);
        this.mainSlider.events.on("indexChanged", (info) => {
          info.slideItems.forEach((item) => {
            if (item.querySelector("video")) {
              item.querySelector("video").pause();
            }
          });
          if (info.slideItems[info.index].querySelector("video")) {
            info.slideItems[info.index].querySelector("video").play();
          }
        });
      }
    },
    initReviewScroll: function() {
      let scrollToReview = document.getElementById("scroll_to_review");
      if (!scrollToReview) {
        return;
      }
      let pos = document.querySelector(".product_tab-contorls").offsetTop;
      let reviewTab = document.querySelector(".tab-controls_item-review");
      scrollToReview.addEvent("click", () => {
        AT.scrollTo(pos);
        reviewTab.click();
        console.log("1");
      });
    },
    handleVariantChange: function(variant) {
      let { productFormInput, productWrapperElement, saleLabelElement, priceCompareElement, priceElement, variantAvailableStatus, skuElement, buttonAddToCart, selectMaster } = this.elms;
      if (!variant) {
        productWrapperElement.setAttribute("data-status", "out-stock");
        return;
      }
      this.currentVariant = variant;
      this.updateURLHash(variant);
      this.updateSubscribeForm(variant);
      let saleLabelElementStyle = saleLabelElement.getAttribute("data-style");
      if (typeof Currencies !== "undefined") {
        if (!!variant.compare_at_price && variant.compare_at_price > variant.price) {
          if (saleLabelElementStyle != "none") {
            saleLabelElement.removeClass("d-none");
            if (saleLabelElementStyle == "percent") {
              let percent = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
              saleLabelElement.innerHTML = "-" + percent + "%";
            }
          }
          priceCompareElement.setAttribute("data-money", variant.compare_at_price);
          priceCompareElement.removeClass("d-none");
        } else {
          if (saleLabelElementStyle != "none") {
            saleLabelElement.addClass("d-none");
          }
          priceCompareElement.addClass("d-none");
        }
        priceElement.setAttribute("data-money", variant.price);
      } else {
        if (!!variant.compare_at_price && variant.compare_at_price > variant.price) {
          if (saleLabelElementStyle != "none") {
            saleLabelElement.removeClass("d-none");
            if (saleLabelElementStyle == "percent") {
              let percent = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
              saleLabelElement.innerHTML = "-" + percent + "%";
            }
          }
          priceCompareElement.innerHTML = variant.compare_at_price.toCurrency();
          priceCompareElement.removeClass("d-none");
        } else {
          if (saleLabelElementStyle != "none") {
            saleLabelElement.addClass("d-none");
          }
          priceCompareElement.addClass("d-none");
        }
        priceElement.innerHTML = variant.price.toCurrency();
      }
      if (variant.available) {
        if (variant.inventory_management) {
          if (variant.inventory_policy == "continue" && variant.inventory_quantity < 1) {
            productWrapperElement.setAttribute("data-status", "back-order");
            buttonAddToCart.querySelector(".btn-label").innerHTML = theme.strings.preOrder;
          } else {
            productWrapperElement.setAttribute("data-status", "in-stock");
            buttonAddToCart.querySelector(".btn-label").innerHTML = theme.strings.addToCart;
          }
          if (variant.inventory_policy == "continue") {
            productFormInput.setAttribute("max", 1e3);
          } else {
            productFormInput.setAttribute("max", variant.inventory_quantity);
          }
        } else {
          productWrapperElement.setAttribute("data-status", "in-stock");
          buttonAddToCart.querySelector(".btn-label").innerHTML = theme.strings.addToCart;
          productFormInput.setAttribute("max", 1e3);
        }
        if (productFormInput.value > Number(productFormInput.getAttribute("max"))) {
          productFormInput.value = Number(productFormInput.getAttribute("max"));
        }
      } else {
        productWrapperElement.setAttribute("data-status", "out-stock");
      }
      if (!!skuElement) {
        !!variant.sku ? (skuElement.innerHTML = variant.sku, skuElement.parentElement.removeClass("d-none")) : skuElement.parentElement.addClass("d-none");
      }
      if (!!variant.featured_image && !!this.mainSlider) {
        this.mainSlider.goTo(variant.featured_image.position - 1);
      }
      selectMaster.value = variant.id;
    },
    updateURLHash(variant) {
      let searchParams = window.location.search.replace("?", "").split("&").filter(Boolean);
      window.history.replaceState({}, "", AT.getParameterByName("variant") ? `${window.location.pathname}?${searchParams.map((param) => param.includes("variant") ? "variant=" + variant.id : param).join("&")}` : (searchParams.unshift("variant=" + variant.id), `${window.location.pathname}?${searchParams.join("&")}`));
    },
    updateSubscribeForm(variant) {
      let { subscribeForm } = this.elms;
      let inputProductName = subscribeForm.querySelector("input[name='contact[product_name]']");
      let inputProductUrl = subscribeForm.querySelector("input[name='contact[product_url]']");
      inputProductName.value = variant.name;
      inputProductUrl.value = inputProductUrl.value.split("?")[0] + "?variant=" + variant.id;
      let subscribeFormWrapper = subscribeForm.querySelector(".js-product-subscribe");
      !AT.getParameterByName("contact_posted") && subscribeFormWrapper.removeClass("posted-successfully");
      subscribeForm.addEvent("submit", () => {
        AT.cookie.set("subscribe-variant-id", this.currentVariant.id);
      });
    },
    switchVariantById(variantId) {
      let { swatchContainer } = this.elms;
      let variantFound = theme.product.variants.find((i) => i.id == variantId);
      if (!variantFound) {
        return;
      }
      variantFound.options.forEach((option, index) => {
        [...swatchContainer.querySelectorAll(`[name='option${index + 1}']`)].find((element) => {
          switch (element.tagName) {
            case "INPUT":
              element.value == option && (element.checked = true, element.dispatchEvent(new Event("change")));
              break;
            case "SELECT":
              element.value = option;
              element.dispatchEvent(new Event("change"));
              break;
          }
        });
      });
    }
  };

  // app/scripts/common/section/related-product.js
  var RelatedProduct = {
    onLoad: function() {
      let { container } = this;
      let sliderContainer = container.querySelector(".js-slider-container");
      let config = JSON.parse(sliderContainer.querySelector("[data-tns-config]").innerHTML);
      config.onInit = () => {
        sliderContainer.addClass("slider-initialized");
      };
      tns(config);
    }
  };

  // app/scripts/common/section/recently-viewed.js
  var RecentlyViewed = {
    onLoad() {
      AT.cookie.get("recently-viewed-products");
      if (AT.cookie.get("recently-viewed-products")) {
        this.getListProducts(AT.cookie.get("recently-viewed-products"));
      }
    },
    getListProducts(arrListProducts) {
      let arrFiltered = arrListProducts.filter((item) => item != theme.product.handle);
      Promise.all(arrFiltered.map((handle) => {
        return fetch(`${theme.routes.searchUrl}?view=product-card&q=${handle}`, { dataType: "text" }).then((res) => {
          let div = document.createElement("div");
          div.addClass("slider-item");
          div.innerHTML = res;
          ProductCard.initEvent(div);
          return div;
        });
      })).then((arrListProductsHTML) => {
        let newArr = arrListProductsHTML.filter(Boolean);
        if (newArr.length) {
          newArr.forEach((item) => {
            this.container.querySelector(".slider-list").append(item);
          });
          this.container.removeClass("d-none");
          this.initSlider();
        }
      });
    },
    initSlider() {
      let config = JSON.parse(this.container.querySelector("[data-tns-config]").innerHTML);
      let sliderContainer = this.container.querySelector(".js-slider-container");
      config.onInit = () => {
        sliderContainer.addClass("slider-initialized");
      };
      tns(config);
    }
  };

  // app/scripts/product-no-sb-page.js
  (() => {
    theme.sectionRegister.forEach((item) => {
      switch (item) {
        case "product-template":
          register(item, ProductNoSbTemplate);
          break;
        case "related-product":
          register(item, RelatedProduct);
          break;
        case "recently-viewed":
          register(item, RecentlyViewed);
          break;
      }
      load("*");
    });
    saveProductToCookie();
  })();
})();
